"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateNativeTestId = exports.updateTestId = void 0;
// `testID` to `data-testid`
const updateTestId = (props) => {
    const newProps = Object.assign({}, props);
    if (newProps.testID) {
        // React Native (Native Testing Library) uses `TestID`
        // but React Web (Testing Library) uses `data-testid`
        newProps['data-testid'] = newProps.testID;
        delete newProps.testID;
    }
    return newProps;
};
exports.updateTestId = updateTestId;
// `data-testid` to `testID`
const updateNativeTestId = (props) => {
    const newProps = Object.assign({}, props);
    if (newProps['data-testid']) {
        // React Web (Testing Library) uses `data-testid`
        // but React Native (Native Testing Library) uses `TestID`
        newProps.testID = newProps['data-testid'];
        delete newProps['data-testid'];
    }
    return newProps;
};
exports.updateNativeTestId = updateNativeTestId;
//# sourceMappingURL=utils.js.map